import React from 'react';
import { useSelector } from 'react-redux';

import EnergyLabelSvg from '../../ProductCard/EnergyInformation/EnergyLabelSvg';
import ProductDataSheet from './CustomCatProductDataSheet@default';

const EnergyInformation = ({ classes, energyRatingDetails }) => {
	const { ListerProductCardEnergyLabelEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!energyRatingDetails) {
		return null;
	}

	const {
		EnergyRatingLabelUrl,
		ProductDatasheetPdfUrl,
		MaxEnergyRating,
	} = energyRatingDetails;

	const is2020Label = MaxEnergyRating === 'A';

	return (
		<div className={classes} data-energyimageurl={EnergyRatingLabelUrl}>
			{!ListerProductCardEnergyLabelEnabled && (
				<EnergyLabelSvg
					{...{
						energyRatingDetails,
						is2020Label,
						customCats: true,
					}}
				/>
			)}
			<ProductDataSheet {...{ ProductDatasheetPdfUrl, customCats: true }} />
		</div>
	);
};

export default EnergyInformation;
